<template>
  <div style="flex: 1">
    <div class="d-flex funnel-filter">
      <div class="form-group mr-2">
        <DropdownCheckbox
          v-model="jobFilterDataModel"
          :options="getManagerJobsDropdown"
          @input="handleJobFilter"
          name="manager-chart-one"
          placeholder="Jobs"
          label="job_name"
        />
      </div>

      <div class="form-group">
        <!-- TIME RANGE -->
        <TimeRange
          name="manager-chart-one-time-range"
          @input="handleTimeRangeFilter"
          v-model="timeRangeDataModel"
        />
        <!-- END TIME REANGE -->
      </div>
    </div>

    <LineChartJobs
      :key="key"
      :chartPropData="getManagerChartOneData"
      v-if="getManagerChartOneData.length"
      :style="myStyles"
    />

    <div class="spinner-container text-center" v-if="isLoading">
      <svgHelper v-show="isLoading" name="loadingSpinner" class="ml-auto justify-items-center" />
    </div>
  </div>
</template>

<script>
import LineChartJobs from '@/components/Manager/Dashboard/Charts/LineChart';
import { mapActions, mapGetters } from 'vuex';

import TimeRange from '@/components/common/TimeRange/TimeRange';
import DropdownCheckbox from '@/components/common/DropdownCheckbox/DropdownCheckbox';

import format from 'date-fns/format';

export default {
  name: 'ChartOne',
  components: {
    LineChartJobs,
    TimeRange,
    DropdownCheckbox,
  },
  data: () => ({
    jobFilterDataModel: [],
    timeRangeDataModel: { value: 'all_time', option: 'All time' },
    jobsForEmployerOptions: [],
    startDate: '',
    endDate: '',
    selectedJobs: [],
    jobsOptions: [],
    chartData: [],
    ids: [],

    isLoading: false,
    key: 0,
    resetInput: false,
    myStyles: {
      position: 'relative',
      height: `${80}%`,
    },
  }),
  methods: {
    ...mapActions('managerStoreModule', [
      'retrieveManagerCharOnetData',
      'retrieveManagerJobsDropdownPipe',
    ]),
    handleJobFilter() {
      //  this.fetchCharOnetData(this.jobFilterDataModel, this.timeRangeDataModel.value);
      this.fetchCharOnetData(this.jobFilterDataModel, this.timeRangeDataModel.value);
    },
    handleTimeRangeFilter() {
      this.fetchCharOnetData(this.jobFilterDataModel, this.timeRangeDataModel.value);
    },
    fetchJobsForSelectedEmployer() {
      this.isLoading = true;

      // Remove previous graph
      this.retrieveCharOnetData({
        jobs_ids: [],
        date: ['all_time'],
      });

      this.retrieveManagerJobsDropdown()
        .then(response => {
          this.jobsOptions = response.data;

          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });

      this.jobFilterDataModel = [];
      this.jobsForEmployerOptions = [];
    },
    formatDates(startDate, endDate) {
      /*  if (startDate) {
        formattedDates = format(startDate, this.dateFormat);
      }

      if (endDate) {
        formattedDates += ' - ' + format(endDate, this.dateFormat);
      } */

      if (startDate && endDate) {
        return `${format(startDate, this.dateFormat)} - ${format(endDate, this.dateFormat)}`;
      }
    },
    fetchCharOnetData(listOfIds, timeRange) {
      this.isLoading = true;

      this.retrieveManagerCharOnetData({
        jobs_ids: [...listOfIds].map(job => job.id),
        date: [timeRange],
      })
        .then(() => {
          this.isLoading = false;
          this.key += 1;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    jobFilterDataModel(newSelectedJob) {
      this.localStoragePlugin.set(
        `${this.getManagerUserProfile.id}-managerChartOneJobSelect`,
        JSON.stringify(newSelectedJob),
      );
    },
    timeRangeDataModel(newSelectedTimeRange) {
      this.localStoragePlugin.set(
        `${this.getManagerUserProfile.id}-managerChartOneTimeRangeSelect`,
        newSelectedTimeRange,
      );
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', [
      'getManagerJobsDropdown',
      'getManagerChartOneData',
      'getManagerUserProfile',
    ]),
  },
  mounted() {
    this.retrieveManagerJobsDropdownPipe()
      .then(response => {
        this.jobsOptions = response.data;

        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });

    if (this.localStoragePlugin.has(`${this.getManagerUserProfile.id}-managerChartOneJobSelect`)) {
      this.jobFilterDataModel = this.localStoragePlugin.get(
        `${this.getManagerUserProfile.id}-managerChartOneJobSelect`,
      );
    }

    if (
      this.localStoragePlugin.has(`${this.getManagerUserProfile.id}-managerChartOneTimeRangeSelect`)
    ) {
      this.timeRangeDataModel = this.localStoragePlugin.get(
        `${this.getManagerUserProfile.id}-managerChartOneTimeRangeSelect`,
      );
    }

    this.retrieveManagerCharOnetData({
      jobs_ids: [...this.jobFilterDataModel.map(j => j.id)],
      date: [this.timeRangeDataModel.value],
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.funnel-filter {
  display: flex;
  padding: 12px;

  .form-group {
    width: 50%;
    flex-shrink: 0;
    .form-control {
      width: 50%;
      flex-shrink: 0;
    }
  }
}
/* 
.multi-level {
  font-size: 144px;
  font-family: $font-family-sans-lato;
  color: #495057;
  li {
    padding: 0;
    a {
      padding: 6px 20px;
    }
  }
} */
</style>
